import styled from 'styled-components';

export const MenuFullWrapper = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.palette.background.paper};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  box-shadow: 0 -8px 6px -6px ${({ theme }) => theme.palette.grey.A200};
  height: 55px;
  padding-top: 12px;
  overflow: hidden;
  z-index: 3;
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

export const IconTitle = styled.h2<{ isSelected: boolean }>`
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 12px;
  color: ${(props) =>
    props.isSelected
      ? props.theme.palette.text.primary
      : props.theme.palette.text.secondary};
`;
